import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface UIState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  // Active sidepanel
  activeSidepanel: string | null;
  sidepanelData: Record<string, unknown> | null;
  openSidepanel: (id: string, data?: Record<string, unknown>) => void;
  closeSidepanel: () => void;
  // Modal/dialog open count — drives the auto-relocate FAB so it doesn't
  // sit on top of an active dialog/sheet/drawer. The FabStackHost runs a
  // MutationObserver that auto-fires push/pop on any
  // `[data-state="open"]` portal node, but any consumer can also write
  // directly. Floor at 0 so a stray pop never breaks the count.
  modalOpenCount: number;
  pushModal: () => void;
  popModal: () => void;
}

export const useUIStore = create<UIState>()(
  devtools(
    persist(
      (set) => ({
        sidebarCollapsed: false,
        toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
        activeSidepanel: null,
        sidepanelData: null,
        openSidepanel: (id, data) => set({ activeSidepanel: id, sidepanelData: data || null }),
        closeSidepanel: () => set({ activeSidepanel: null, sidepanelData: null }),
        modalOpenCount: 0,
        pushModal: () => set((s) => ({ modalOpenCount: s.modalOpenCount + 1 })),
        popModal: () => set((s) => ({ modalOpenCount: Math.max(0, s.modalOpenCount - 1) })),
      }),
      {
        name: 'hf-ui',
        partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed }),
      },
    ),
    { name: 'UIStore' },
  ),
);
